import { IHubInitialState } from "../../../types/master/hubInterface";
import { HubActionTypes, HubActions } from "../../actionTypes/master/hubActionTypes";


const initialState: IHubInitialState = {
  hubList: [],
  hubData: {
    id: 0,
    hub_name: "",
    slug: "",
    hub_code: "",
    location: "",
    address: "",
    email: "",
    contact_number: "",
    created_by: 0,
    createdAt: "",
    updatedAt: "",
  },
  hubListPageCount: 0,
};

export default function hubReducer(state = initialState, action: HubActionTypes): IHubInitialState {
  switch (action.type) {

    case HubActions.SET_HUB_LIST:
      return {
        ...state,
        hubList: action.payload    
      };

    case HubActions.SET_HUB_LIST_PAGE_COUNT:
      return {
        ...state,
        hubListPageCount: action.payload
      };

    case HubActions.SET_HUB_DATA_BY_ID:
      return {
        ...state,
        hubData: action.payload
      }

    default:
      return state;
  }
}
